import React__default, { useCallback } from 'react';
import { useIdle } from '../../../hooks/useIdle.js';

const withIdleWrapper = (Component) => {
    const WrappedComponent = props => {
        const propsFromIdle = useIdle();
        const handleClose = useCallback(() => {
            propsFromIdle.onClose();
            props.onClose && props.onClose();
        }, [props, propsFromIdle]);
        const propsForComponent = {
            ...propsFromIdle,
            ...props,
            onClose: handleClose,
        };
        return React__default.createElement(Component, { ...propsForComponent });
    };
    WrappedComponent.displayName = `withIdleWrapper(${Component.displayName})`;
    return WrappedComponent;
};

export { withIdleWrapper };
//# sourceMappingURL=WithIdleWrapper.js.map
